export default [
  {
    Id: '1',
    Tipscore: 100,
    Name: '青铜III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/qingtong3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/qtI.png',
  },
  {
    Id: '2',
    Tipscore: 200,
    Name: '青铜II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/qingtong2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/qtII.png',
  },
  {
    Id: '3',
    Tipscore: 300,
    Name: '青铜I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/qingtong1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/qtI.png',
  },
  {
    Id: '4',
    Tipscore: 400,
    Name: '白银III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/baiyin3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/byIII.png',
  },
  {
    Id: '5',
    Tipscore: 500,
    Name: '白银II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/baiyin2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/byII.png',
  },
  {
    Id: '6',
    Tipscore: 600,
    Name: '白银I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/baiyin1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/byI.png',
  },
  {
    Id: '17',
    Tipscore: 700,
    Name: '黄金IV',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/huangjin4.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/hjIV.png',
  },
  {
    Id: '7',
    Tipscore: 800,
    Name: '黄金III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/huangjin3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/hjIII.png',
  },
  {
    Id: '8',
    Tipscore: 900,
    Name: '黄金II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/huangjin2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/hjII.png',
  },
  {
    Id: '9',
    Tipscore: 1000,
    Name: '黄金I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/huangjin1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/hjI.png',
  },
  {
    Id: '18',
    Tipscore: 1100,
    Name: '铂金V',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/bojin5.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/bjV.png',
  },
  {
    Id: '19',
    Tipscore: 1200,
    Name: '铂金IV',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/bojin4.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/bjIV.png',
  },
  {
    Id: '10',
    Tipscore: 1300,
    Name: '铂金III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/bojin3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/bjIII.png',
  },
  {
    Id: '11',
    Tipscore: 1400,
    Name: '铂金II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/bojin2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/bjII.png',
  },
  {
    Id: '12',
    Tipscore: 1500,
    Name: '铂金I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/bojin1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/bjI.png',
  },
  {
    Id: '20',
    Tipscore: 1600,
    Name: '钻石V',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zuanshi5.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zsV.png',
  },
  {
    Id: '21',
    Tipscore: 1700,
    Name: '钻石IV',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zuanshi4.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zsIV.png',
  },
  {
    Id: '13',
    Tipscore: 1800,
    Name: '钻石III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zuanshi3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zsIII.png',
  },
  {
    Id: '14',
    Tipscore: 1900,
    Name: '钻石II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zuanshi2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zsII.png',
  },
  {
    Id: '15',
    Tipscore: 2000,
    Name: '钻石I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zuanshi1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zsI.png',
  },
  {
    Id: '22',
    Tipscore: 2100,
    Name: '星耀V',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zz5.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zzV.png',
  },
  {
    Id: '23',
    Tipscore: 2200,
    Name: '星耀IV',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zz4.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zzIV.png',
  },
  {
    Id: '24',
    Tipscore: 2300,
    Name: '星耀III',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zz3.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zzIII.png',
  },
  {
    Id: '25',
    Tipscore: 2400,
    Name: '星耀II',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zz2.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zzII.png',
  },
  {
    Id: '26',
    Tipscore: 2500,
    Name: '星耀I',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/zz1.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/zzI.png',
  },
  {
    Id: '16',
    Tipscore: 2600,
    Name: '王者',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/wangzhe.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/wz.png',
  },
  {
    Id: '30',
    Tipscore: 2700,
    Name: '王者25星',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/wangzhe.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/wz.png',
  },
  {
    Id: '31',
    Tipscore: 2800,
    Name: '王者50星',
    Pic: 'http://ossweb-img.qq.com/images/Tip/Level/wangzhe.png',
    Picbig: 'http://ossweb-img.qq.com/images/Tip/Level/wz.png',
  },
];

